export const languageList = [
  {
    label: 'Tiếng Việt',
    value: 'vi',
  },
  {
    label: 'English',
    value: 'en',
  },
];

export const samplePage = [...Array(10)].map((_, idx) => ({
  label: `Trang mẫu ${idx + 1}`,
  value: `${idx + 1}`,
}));

export const statusDummy = [
  {
    label: 'Bản nháp',
    value: 1,
  },
  {
    label: 'Gửi duyệt',
    value: 7,
  },
  {
    label: 'Đã duyệt',
    value: 13,
  },
];

export const contactStatusDummy = [
  {
    label: 'Mới',
    value: 1,
  },
  {
    label: 'Chờ duyệt',
    value: 7,
  },
  {
    label: 'Đã duyệt',
    value: 13,
  },
];

export const heartRisk = [
  {
    label: 'Chưa đủ thông tin đánh giá yếu tố nguy cơ tim mạch',
    value: 'missingHeartRisk',
  },
  {
    label: 'N/a',
    value: 'na',
  },
  {
    label: 'Trống',
    value: 'empty',
  },
  {
    label: 'Không biết',
    value: 'unknow',
  },
  {
    label: 'Thấp',
    value: 'low',
  },
  {
    label: 'Trung bình',
    value: 'medium',
  },
  {
    label: 'Cao',
    value: 'high',
  },
  {
    label: 'Rất cao',
    value: 'veryHigh',
  },
  {
    label: 'Cao và rất cao',
    value: 'highAndVeryHigh',
  },
  {
    label: 'Thấp và trung bình',
    value: 'lowAndMedium',
  },
];

export const userFilter = [
  {
    label: 'filterField.yes',
    value: '1',
  },
  {
    label: 'filterField.no',
    value: '2',
  },
];

export const sampleType = [
  {
    value: 0,
    label: 'All',
  },
  {
    value: 1,
    label: 'QR Code',
  },
  {
    value: 2,
    label: 'Kiosk',
  },
  {
    value: 3,
    label: 'HIS',
  },
];

export const sampleTypeTable = [
  {
    value: 1,
    label: 'QR Code',
  },
  {
    value: 2,
    label: 'Kiosk',
  },
  {
    value: 3,
    label: 'HIS',
  },
];

export const sampleTypeExtend = [
  {
    value: 0,
    label: 'All',
  },
  {
    value: 1,
    label: 'QR Code',
  },
  {
    value: 2,
    label: 'Kiosk',
  },
  {
    value: 3,
    label: '<450',
  },
];

export const sampleType2 = [
  {
    value: 40,
    label: '>= 40',
  },
  {
    value: 69,
    label: '40 - 69',
  },
  {
    value: 70,
    label: '>= 70',
  },
];
